import React from 'react';
import PropTypes from 'prop-types';
import { useUser } from '@lore/auth';
import RedirectChoice from './RedirectChoice';
import useRouter from '../../../hooks/useRouter';
import { UserIcon, UsersIcon } from '@heroicons/react/24/outline';

export default function ExplorePotentialPartnersChoice(props) {
  const { history } = useRouter();

  const currentUser = useUser();

  return (
    <RedirectChoice
      icon={UsersIcon}
      title="Explore potential community partners."
      onClick={() => history.push({
        pathname: '/partners',
        search: stringify({
          locationCondition: JSON.stringify({
            address: currentUser.data.zipCode,
            latitude: currentUser.data.latitude,
            longitude: currentUser.data.longitude,
            radius: 50
          })
        })
      })}
    />
  );
};
